export const CONSULTATION_WINDOW_MS = 15 * 24 * 60 * 60 * 1000;
export const CHAT_INACTIVITY_WINDOW_MS = 24 * 60 * 60 * 1000;

export type ConsultationAccess =
  | "pending"
  | "payment_required"
  | "open"
  | "locked"
  | "expired"
  | "rejected";

export interface ConsultationAccessConversation {
  status: string;
  paid: boolean;
  created_at?: string | null;
  consultation_started_at?: string | null;
  consultation_expires_at?: string | null;
  chat_unlocked_until?: string | null;
}

export function getConsultationAccess(
  conversation: ConsultationAccessConversation,
  now = Date.now(),
): ConsultationAccess {
  if (conversation.status === "pending") return "pending";
  if (conversation.status === "rejected") return "rejected";
  if (conversation.status !== "accepted" || !conversation.paid) {
    return "payment_required";
  }

  const startedAt = new Date(
    conversation.consultation_started_at ??
      conversation.created_at ??
      new Date(now).toISOString(),
  ).getTime();
  const expiresAt = new Date(
    conversation.consultation_expires_at ??
      new Date(startedAt + CONSULTATION_WINDOW_MS).toISOString(),
  ).getTime();

  if (now >= expiresAt) return "expired";

  const unlockedUntil = new Date(
    conversation.chat_unlocked_until ??
      new Date(startedAt + CHAT_INACTIVITY_WINDOW_MS).toISOString(),
  ).getTime();

  return now < unlockedUntil ? "open" : "locked";
}

export function getConsultationExpiry(
  startedAt: string,
): string {
  return new Date(
    new Date(startedAt).getTime() + CONSULTATION_WINDOW_MS,
  ).toISOString();
}

export function getChatUnlockedUntil(
  activityAt: string,
  consultationExpiresAt: string,
): string {
  return new Date(
    Math.min(
      new Date(activityAt).getTime() + CHAT_INACTIVITY_WINDOW_MS,
      new Date(consultationExpiresAt).getTime(),
    ),
  ).toISOString();
}